import { render, staticRenderFns } from "./UserTabBillingsPlans.vue?vue&type=template&id=ca7605e0"
import script from "./UserTabBillingsPlans.vue?vue&type=script&lang=js"
export * from "./UserTabBillingsPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports